import { MODAL_CONTENT_FRAGMENT } from './ModalContentFragment'

export const ACTION_FRAGMENT = `{
  type
  title
  navigationType
  navigationTarget
  modalContent ${MODAL_CONTENT_FRAGMENT}
}`
